const urlParams = new URLSearchParams(window.location.search)
const isElectronProd = urlParams.get('electron-prod')

const AppConfig = {
  apiUrl: './export'
}

export default AppConfig
